module.exports = __webpack_public_path__ + "img/urvalssortering.f6cdbcfd.jpg";